import type { ScreenBase } from "@frui.ts/screens";
import { BusyWatcher, ConductorOneChildActive, watchBusy } from "@frui.ts/screens";
import { action, observable } from "mobx";

export default abstract class DetailViewModelWithChildren<
  TDetail,
  TChild extends ScreenBase
> extends ConductorOneChildActive<TChild> {
  protected abstract loadDetail(): Promise<TDetail> | TDetail;
  busyWatcher = new BusyWatcher();
  @observable item: TDetail;

  @action.bound
  setItem(item: TDetail) {
    this.item = item;
  }

  @watchBusy
  async onInitialize() {
    try {
      const item = await this.loadDetail();
      this.setItem(item);

      if (!this.activeChild && this.children.length) {
        this.tryActivateChild(this.children[0]);
      }
    } catch (e) {
      this.requestClose();
    }

    super.onInitialize();
  }
}
